module.exports = __webpack_public_path__ + "static/img/1.eb40ad3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/zh/1.png
// module id = MNIU
// module chunks = 0